/**
 * Component Registry for Sunrise Management Theme
 * 
 * Extends the base landing-page theme registry with Sunrise Management specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';

/**
 * Sunrise Management specific component overrides.
 * These components have been customized for the Sunrise Management brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const sunrisemanagementOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const sunrisemanagementOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Sunrise Management properties.
 * Inherits all components from the landing-page theme, with Sunrise Management overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...sunrisemanagementOverrides,
};

export default registry;
